export class BackupScopeSummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "totalResources",
            "baseName": "totalResources",
            "type": "number",
            "format": ""
        },
        {
            "name": "scopeResources",
            "baseName": "scopeResources",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupScopeSummary.attributeTypeMap;
    }
    constructor() {
    }
}
